import type { PubSubData } from "@/types";

/**
 * Creates an array of dropdown options with sequential numbers
 * @param length - Number of options to create
 * @returns Array of dropdown options with text and value
 */
export const createNumberOptions = (length: number) =>
  Array.from({ length }, (_, i) => ({
    text: (i + 1).toString(),
    value: (i + 1).toString(),
  }));

/**
 * Generic form update control handler for PubSub events
 * @param data - PubSub data with context and value
 * @param updateForm - Function to update form state
 */
export const createUpdateControl = <T extends Record<string, any>>(
  updateForm: (data: Partial<T>) => void,
) => {
  return (data: PubSubData & { context: keyof T }) => {
    updateForm({ [data.context]: data.value } as Partial<T>);
  };
};
